import { FolderableType } from 'FoldersApp/enums/folderable-type.enum';
import { SelectedFolderableService } from 'FoldersApp/services/selected-folderable.service';
import * as i0 from "@angular/core";
export class SelectedAnalysisPlanService extends SelectedFolderableService {
    constructor() {
        super(...arguments);
        this.RESOURCE_TYPE = FolderableType.ANALYSIS_PLAN;
        this.ITEM_ID_SLICE_KEY = 'analysisPlanId';
    }
}
SelectedAnalysisPlanService.ɵfac = /*@__PURE__*/ (() => { let ɵSelectedAnalysisPlanService_BaseFactory; return function SelectedAnalysisPlanService_Factory(__ngFactoryType__) { return (ɵSelectedAnalysisPlanService_BaseFactory || (ɵSelectedAnalysisPlanService_BaseFactory = i0.ɵɵgetInheritedFactory(SelectedAnalysisPlanService)))(__ngFactoryType__ || SelectedAnalysisPlanService); }; })();
SelectedAnalysisPlanService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SelectedAnalysisPlanService, factory: SelectedAnalysisPlanService.ɵfac });
